// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ez","header":"i_E0","icon":"i_E1","intro":"i_E2","title":"i_E3","description":"i_E4"};